import { render, staticRenderFns } from "./applyText.vue?vue&type=template&id=44fbfa5b&"
import script from "./applyText.vue?vue&type=script&lang=js&"
export * from "./applyText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports